import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
} from "../../../helpers/fakebackend_helper";
import { getPostLoginRedirectPath } from "../../../helpers/auth_api";

const fireBaseBackend = getFirebaseBackend();

interface LoginUserAction {
  type: string;
  payload: {
    user: {
      email: string;
      password: string;
      [key: string]: any;
    };
    history: (path: string) => void;
  };
}

interface LogoutUserAction {
  type: string;
  payload: {
    history: (path: string) => void;
  };
}

interface SocialLoginAction {
  type: string;
  payload: {
    type: string;
    history: (path: string) => void;
  };
}

function* loginUser(action: LoginUserAction): Generator<any, void, any> {
  const { payload: { user, history } } = action;
  try {
    let loginResponse: { role?: string } | undefined;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      if (fireBaseBackend) {
        loginResponse = yield call(
          fireBaseBackend.loginUser,
          user.email,
          user.password
        );
        yield put(loginSuccess(loginResponse));
      }
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      loginResponse = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      });
      localStorage.setItem("authUser", JSON.stringify(loginResponse));
      yield put(loginSuccess(loginResponse));
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      loginResponse = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      });
      localStorage.setItem("authUser", JSON.stringify(loginResponse));
      yield put(loginSuccess(loginResponse));
    }

    history(getPostLoginRedirectPath(loginResponse?.role));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser(action: LogoutUserAction): Generator<any, void, any> {
  const { payload: { history } } = action;
  try {
    localStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      if (fireBaseBackend) {
        yield call(fireBaseBackend.logout);
        yield put(logoutUserSuccess());
      }
    }
    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin(action: SocialLoginAction): Generator<any, void, any> {
  const { payload: { type, history } } = action;
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      if (fireBaseBackend) {
        const response = yield call(fireBaseBackend.socialLoginUser, type);
        if (response) {
          history("/dashboard");
        } else {
          history("/login");
        }
        localStorage.setItem("authUser", JSON.stringify(response));
        yield put(loginSuccess(response));
      }
    }
    if (fireBaseBackend) {
      const response = yield call(fireBaseBackend.socialLoginUser, type);
      if(response)
      history("/dashboard");
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga(): Generator<any, void, any> {
  yield takeEvery(LOGIN_USER as any, loginUser);
  yield takeLatest(SOCIAL_LOGIN as any, socialLogin);
  yield takeEvery(LOGOUT_USER as any, logoutUser);
}

export default authSaga;
